export type TValidationPatterns =
  | 'hebrewChars'
  | 'hebrewName'
  | 'englishName'
  | 'englishVowels'
  | 'mobilePhone'
  | 'mobileAreaCode'
  | 'hebrewAlphabetical'
  | 'hebrewAlphaNumeric'
  | 'email'
  | 'idNumber'
  | 'numeric'
  | 'decimal'
  | 'formattedDecimal'
  | 'nonZeroDigits'
  | 'hebConsecutive3'
  | 'hebConsecutive2'
  | 'engConsecutive3'
  | 'engConsecutive2'
  | 'hebrewPhrase'
  | 'hebSuffixLetters'
  | 'localeDate';

export const ValidationPatterns: { [key in TValidationPatterns]: RegExp } = {
  hebrewChars: /^[א-ת]*$/,
  hebrewName: /^[א-ת-'"׳`‘ ’]*$/,
  hebrewAlphabetical: /^[א-ת-\'&quot ]*$/,
  hebrewAlphaNumeric: /^[A-Za-z0-9א-ת-()\n:.,/' ]*$/,
  englishName: /^[a-zA-Z-_\' ]*$/,
  englishVowels: /[AOUIEUY]{1,}/,
  email: /^$|^([0-9a-zA-Z_](?:[-.]*\w)*@(?:[0-9a-zA-Z](?:[-_]*[0-9a-zA-Z])*\.)+[a-zA-Z]{2,9})$/,
  mobilePhone: /^[0][5][0|1|2|3|4|5|7|8]{1}[-]{0,1}[1-9]{1}[0-9]{6}$/,
  mobileAreaCode: /^[0][5][0|1|2|3|4|5|7|8]{1}/,
  numeric: /^\d*$/,
  decimal: /^[+-]?([0-9]*[.])?[0-9]+$/,
  formattedDecimal: /^(\d+(?:\.\d+)?|\.\d+|\d{1,3}(?:,\d{3})+(?:\.\d+)?)$/,
  idNumber: /^\d{9}$/,
  nonZeroDigits: /^[1-9]*$/,
  hebConsecutive3: /([א-ת])\1\1/,
  hebConsecutive2: /([א-ת])\1/,
  engConsecutive3: /([A-Za-z])\1\1/,
  engConsecutive2: /([A-Za-z])\1/,
  localeDate: /\d{2}\/\d{2}\/\d{4}?/,
  hebSuffixLetters: /(^[םןץףך]|.(ם|ן|ץ|ף|ך)(?=[א-ת]))/,
  hebrewPhrase: /^[א-ת-\'" ]*$/
};
